<template>
  <div class="flex flex-col bg-white px-2">
    <div class="flex mt-5 justify-center" v-if="title != 'production'">
      <app-title>{{ title }}</app-title>
    </div>
    <div class="flex flex-col gap-[5px] pt-3 mt-3">
      <db-form class="flex flex-col gap-[5px]">
        <db-input
          variant="outline"
          :placeholder="$t('login.username') + '*'"
          :label="$t('login.username') + '*'"
          name="username"
          :ariainvalid="errors.username ? 'true' : ''"
          v-model="user.username"
        ></db-input>
        <DbPasswordInput
          v-model="user.password"
          :placeholder="$t('login.password') + '*'"
          :label="$t('login.password') + '*'"
          :ariainvalid="errors.username ? 'true' : ''"
          variant="outline"
          name="password"
        />
        <p
          :class="
            errors.username == true && errors.password == true
              ? 'flex text-red-700 justify-center mt-2 text-sm'
              : 'hidden'
          "
        >
          {{ $t("login.error") }}
        </p>
        <db-button
          id="login"
          variant="brand-primary"
          class-list="w-full mt-2"
          @click="login"
        >
          {{ $t("login.login") }}
        </db-button>
      </db-form>
      <router-link class="w-full" to="/reset-password-guest">
        <db-button variant="tertiary-plain" class-list="w-full">
          {{ $t("landing.login.reset_password") }}
        </db-button>
      </router-link>
      <div class="flex w-full pt-16">
        <p class="text-sm text-gray-400">
          {{ $t("landing.required_field") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import store from "@/store";
import firebaseAuthService from "@/services/FirebaseAuthService";
import AppTitle from "@/components/AppTitle.vue";
import DbInput from "@/components/DB-Components/DbInput.vue";
import DbButton from "@/components/DB-Components/DbButton.vue";
import DbPasswordInput from "@/components/DB-Components/DbPasswordInput.vue";

export default defineComponent({
  components: { AppTitle, DbInput, DbButton, DbPasswordInput },
  name: "LoginComponent",

  setup() {
    const router = useRouter();
    const title = process.env.NODE_ENV;
    const user = ref({
      username: "",
      password: "",
    });

    const errors = ref({
      username: false,
      password: false,
    });

    const addUser = async (user: any) => {
      await store.dispatch("addUser", user);
    };

    const resetErrors = () => {
      errors.value = {
        username: false,
        password: false,
      };
    };

    const login = async () => {
      await store.dispatch("toggleLoading", true);
      resetErrors();

      await firebaseAuthService
        .login(user.value.username, user.value.password)
        .then(async (response) => {
          await addUser(response);
        })
        .then(async (_response) => {
          console.log(store.state.user.data.user_id);
          const userHasAcceptedTerms = await store.dispatch(
            "UserStore/getTermsAccepted",
            store.state.user.data.user_id
          );
          if (userHasAcceptedTerms) {
            router.push("/");
          } else {
            router.push("/acceptTerms");
          }
        })
        .catch((error) => {
          errors.value = {
            username: true,
            password: true,
          };
        });
      await store.dispatch("toggleLoading", false);
    };

    return {
      user,
      login,
      title,
      errors,
    };
  },
});
</script>
